import React from 'react';
import { IIconProps } from '../interfaces';
const WishlistIcon = (props: IIconProps) => {
    const width=parseInt(props.width);
  return (
      <svg width={width} height={(width - 1)} viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink">
          <defs>
              <path d="M8.084 12.72c3.812-3.54 5.008-4.799 5.788-6.283.36-.684.528-1.308.528-1.941 0-1.615-1.22-2.861-2.8-2.861-.898 0-1.797.432-2.382 1.133L8 4.23 6.782 2.768C6.197 2.067 5.298 1.635 4.4 1.635c-1.58 0-2.8 1.246-2.8 2.86 0 .637.17 1.263.533 1.951.783 1.482 1.986 2.747 5.784 6.266l.087.081.08-.074zm-1.22-12L8 1.708 9.136.72A4.67 4.67 0 0 1 11.6 0C14.064 0 16 1.978 16 4.496c0 3.09-2.72 5.608-6.84 9.433L8 15l-1.16-1.079C2.72 10.104 0 7.586 0 4.496 0 1.978 1.936 0 4.4 0a4.67 4.67 0 0 1 2.464.72z" id="yjwbm2s1ca"/>
          </defs>
          <use fill={props.color} fillRule="nonzero" xlinkHref="#yjwbm2s1ca"/>
      </svg>
  )
};

export default WishlistIcon;